import {Form} from "react-bootstrap";
import React from "react";
import {getIn} from 'formik';
import Label from "./Label";

export default ({
  label,
  name,
  type,
  value,
  formik,
  isValidating,
  placeHolder,
  isRequired,
  disabled,
  as
}) => {

  const {handleChange, handleBlur, values, errors, touched} = formik;
  const fieldValue = getIn(values, name);
  const showError = (getIn(touched, name) || isValidating) && getIn(errors,
      name);

  if (type === "radio") {
    // Handle radio specifically
    return (<>
          <Form.Check
              type="radio"
              name={name}
              label={label}
              onChange={handleChange}
              onBlur={handleBlur}
              value={value}
              // Radio is checked if the current form state matches this radio's "value"
              checked={fieldValue === value}
              isInvalid={!!showError}
              disabled={disabled}
          />
          {showError && (<Form.Control.Feedback type="invalid">
                {getIn(errors, name)}
              </Form.Control.Feedback>)}
        </>);
  }

  // Otherwise handle as text/select/textarea
  return (<>
        <Label text={label} hasHint={isRequired} hint={"(privaloma)"}/>
        <Form.Control
            type={type}
            name={name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={fieldValue}
            isInvalid={!!showError}
            className="form__input"
            placeholder={placeHolder}
            disabled={disabled}
            as={as || 'input'}
        />
        {showError && (<Form.Control.Feedback type="invalid">
              {getIn(errors, name)}
            </Form.Control.Feedback>)}
      </>);
};
